import loadProductCategories from "@dillon/Store/Handlers/Custom/LoadProductCategories";
import { setGA4Event } from "@dillon/Store/Handlers/Utilities/CustomTracking";
import { mapStateToProps } from "@dillon/Widgets/VerndaleBox/FooterContainer";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { HasProductContext, ProductContextModel, withProductContext } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel;
    onClick?: React.EventHandler<React.MouseEvent>;
    extendedStyles?: ProductDescriptionStyles;
}

 // Verndale customization ticket: DSSM-453
 const mapDispatchToProps = {
    loadProductCategories,
};

 type Props = ReturnType<typeof mapStateToProps> &
 OwnProps &
 ResolveThunks<typeof mapDispatchToProps> &
 HasProductContext;

 // End of Verndale customization ticket: DSSM-453

export interface ProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
}

export const productDescriptionStyles: ProductDescriptionStyles = {
    productDetailLink: {
        css: css`
            width: 100%;
        `,
        typographyProps: {
            css: css`
                width: 100%;
                ${wrapInContainerStyles}
            `,
        },
    },
};

const ProductDescription = ({ product, onClick, extendedStyles, loadProductCategories }: Props) => {
    const [styles] = useState(() => mergeToNew(productDescriptionStyles, extendedStyles));

    const description =
        "product" in product
            ? product.product.productTitle
            : product.shortDescription || ("description" in product ? product.description : "");
    const productDetailPath = "product" in product ? product.productInfo.productDetailPath : product.productUri;


     // Verndale customization ticket: DSSM-453
     const customClickHandler = (e: React.MouseEvent) => {
        if (onClick) {
            onClick(e);
        }

        // if product is of type CartLineModel, then we need to get the productId from pricing object
        // else if is orderLineModel, then we need to get the productId property, else we can get the productId from productInfo object

        let productId = "";

        if ("product" in product) {
            productId = (product as ProductContextModel).productInfo.productId;
        } else {
            productId = (product as CartLineModel).productId!;
        }

        loadProductCategories({
            productIds: [productId],
            type: "product",
            onComplete: data => {
                const productCategories = data.apiResult?.find(category => category.id === productId);
                const products = [product];
                setGA4Event(products, "select_item", {
                    productCategories,
                    // productsPricingPrices: pricing ? [pricing] : undefined,
                });
            },
        });
    };
    // End of Verndale customization ticket: DSSM-453

    return productDetailPath && (!("isActiveProduct" in product) || product.isActiveProduct) ? (
        <Link
            {...styles.productDetailLink}
            href={productDetailPath}
            alt={`See product details for ${description}`}
            onClick={customClickHandler} // Verndale: Custom tracking
            data-test-selector="productDescriptionLink"
        >
            {description}
        </Link>
    ) : (
        <Typography {...styles.productDetailDescription}>{description}</Typography>
    );
};

export default withProductContext(connect(mapStateToProps, mapDispatchToProps)(ProductDescription as any) as any);
